import React from 'react';
import OrderContentComponent from './src/components/order-context';

export const wrapRootElement = ({ element }) => {
  return <OrderContentComponent>{element}</OrderContentComponent>;
};
